import util from "zmfront-framework/src/utils/util";
import http from "zmfront-framework/src/utils/httpservice";

const zmRemoteFee = {};

//偏远费查询
zmRemoteFee.call=async function (param){
    var bo={
        fee:0,
        currency:'',
        formula:'',
    };
    await dateFeeCaChe();
    //1.获取缓存
    let remoteFeeData=await getCacheRefresh("remotefe");
    return  new Promise((resolve,reject)=>{
        //无数据，返回
        if(!param){
            resolve(bo) ;
        }
        let remoteFeeList=remoteFeeData.list;
        //2.判断是否有数据，无数据直接返回
        if(remoteFeeList==null || remoteFeeList.length<1){
            bo.fee=0;
            bo.str=0;
            bo.currency=param.currency;
            resolve(bo);
        }else{
            let remotefee={};
            //3.有数据,判断list是否符合条件
            for (var i = 0; i < remoteFeeList.length; i++) {
                let hubinIds=remoteFeeList[i].hubinIds;
                if(hubinIds!=null && hubinIds!=undefined && hubinIds!=''){
                    if(hubinIds.indexOf(",")!=-1){
                        var str= hubinIds.split(',');
                        for(var j=0;j<str.length;j++){
                            if(str[j]==param.hubInId && (remoteFeeList[i].packing==param.packing || (!remoteFeeList[i].packing))){
                                remotefee=remoteFeeList[i];
                                break;
                            }
                        }
                    }else{
                        if(remoteFeeList[i].hubinIds==param.hubInId && (remoteFeeList[i].packing==param.packing || (!remoteFeeList[i].packing))){
                            remotefee=remoteFeeList[i];
                            break;
                        }
                    }
                }
            }
            if(!remotefee || remotefee==null || remotefee==undefined || remotefee=='' || remotefee.id<=0 || JSON.stringify(remotefee) == "{}") {
                //4.有数据,判断list是否符合条件
                for(var i=0;i<remoteFeeList.length;i++){
                    if(remoteFeeList[i].hubType==param.hubType  &&
                        (remoteFeeList[i].packing==param.packing || (!remoteFeeList[i].packing))){
                        //4.符合条件，赋值并只取一个值并跳出for
                        remotefee=remoteFeeList[i];
                        break;
                    }
                }
            }

            //5.1传入参数
            let paramTms={
                countryCode:param.countryCode,
                remoteType:remotefee.postalType,
                zip:param.zip,
                city:param.cityEn,
                currentPage:1,
                pageSize:50,
                posMapping:"posEdi/remoteZip/list",
                source:"tms"
            };
            //5.2请求地址  请求成功，获取返回结果
            http.get("/pos/edi/posGet",{
                str:JSON.stringify(paramTms)
            },{isShowMessage:1}).then(async res => {
                if (!res || res.list < 1) {
                    //5.3 判断是否有值返回，没有就不是偏远
                    bo.fee = 0;
                    bo.str = 0;
                    bo.currency = param.currency;
                    resolve(bo);
                } else {
                    bo.DataList = res;
                    bo.remotefee = remotefee;
                    //7.1 计算
                    var fee = parseFloat((param.weig * remotefee.unitPrice).toFixed(3));
                    var str = "(" + param.weig + "*" + remotefee.unitPrice + ")";
                    var finalFee = 0;
                    var formula = "";
                    if (remotefee.maxPrice > 0) {
                        finalFee = (fee > remotefee.maxPrice) ? remotefee.maxPrice : fee;
                        str = (fee > remotefee.maxPrice) ? parseFloat(remotefee.maxPrice.toFixed(2)) + "" : parseFloat(fee.toFixed(2)) + "";
                    } else {
                        finalFee = fee;
                    }
                    if (remotefee.minPrice > 0) {
                        finalFee = (finalFee < remotefee.minPrice) ? remotefee.minPrice : finalFee;
                        str = (finalFee < remotefee.minPrice) ? parseFloat(remotefee.minPrice.toFixed(2)) + "" : parseFloat(finalFee.toFixed(2)) + "";
                    }
                    let quoteFuelList = await getCacheRefresh("quotefuel");
                    let quoteFuel = {};
                    if (quoteFuelList && quoteFuelList.length > 0) {
                        for (var is = 0; is < quoteFuelList.length; is++) {
                            let hubinIds = quoteFuelList[is].hubIdList;
                            if (hubinIds != null && hubinIds != undefined && hubinIds != '' && hubinIds.length > 0) {
                                for (var k = 0; k < hubinIds.length; k++) {
                                    if (hubinIds[k] == param.hubInId) {
                                        quoteFuel = quoteFuelList[is];
                                        break;
                                    }
                                }
                            }
                        }
                        if (!quoteFuel || quoteFuel == null || quoteFuel == undefined || quoteFuel == '' || quoteFuel.id <= 0 || JSON.stringify(quoteFuel) == "{}") {
                            for (var i = 0; i < quoteFuelList.length; i++) {
                                //4.2去自己创建的数据
                                if (quoteFuelList[i].hubType == param.hubType && quoteFuelList[i].ardedNo == '01') {
                                    quoteFuel = quoteFuelList[i];
                                    break;
                                }
                            }
                        }
                        formula = finalFee;
                        if (null != quoteFuel && quoteFuel != undefined && quoteFuel.fuelRate != null) {
                            finalFee = finalFee * (1 + (quoteFuel.fuelRate));
                            formula = formula + "*(1+(" + quoteFuel.fuelRate + "))";
                            str = str + "*(1+(" + quoteFuel.fuelRate + "))";
                        }
                    }
                    bo.str = str;
                    bo.formula = str;
                    //8.获等最终值，赋值
                    bo.fee = finalFee;
                    bo.fee = parseFloat((bo.fee).toFixed(2));
                    bo.currency = (remotefee.currency != null ? remotefee.currency : param.currency);
                    console.log(bo);
                    // 9. 判断是否转本币结算
                    if (remotefee.isStandard && remotefee.isStandard == 1) {
                        let exch = await getOtherExch({custId: param.custId, change: 1000, cur: bo.currency});
                        if (bo.currency != exch.cur) {
                            bo.fee =parseFloat((bo.fee*exch.exch).toFixed(2));
                            bo.formula="("+bo.formula+")*"+exch.exch;
                            bo.str = bo.formula;
                            bo.currency=exch.cur;
                        }
                    }
                    // 10. 结束，返回
                    resolve(bo);
                }
            })
                .catch(res =>{
                    //返回
                    bo.fee=0;
                    bo.str=0;
                    bo.formula='';
                    bo.currency=param.currency;
                    resolve(bo);
                });
        }
    });

};

const dateFeeCaChe=async function (){
    var strs= await getCacheRefresh("strDate");
    var sdate = strs.split('-');
    var date1 = new Date(sdate[0], sdate[1]-1, sdate[2]);

    let strDate=new Date();
    var jshu=strDate.getFullYear() + '-' + (strDate.getMonth() + 1) + '-' + strDate.getDate();
    var str=jshu.split('-');
    var dec = new Date(str[0], str[1]-1, str[2]);
    if(date1.getTime()<dec.getTime()) {
        await loginQuoteRemotefee();
        await loginQuoteRemotefeeUrl();
        await loginQuotepremiumfee();
        await loginPackingOpt();
        await loginPackingFee();
        await loginQuotefuel();
        util.remove("strDate");
        util.set("strDate",jshu);
    }
};
//没有对应的缓存就刷新缓存，有就直接返回缓存
const getCacheRefresh = function (str) {
    return new Promise((resolve,reject) => {
        if(str){
            //打开日期缓存 不存在就重新缓存
            if(str=="strDate"){
                let strDate =  util.get("strDate");
                if(strDate){
                    resolve(strDate);
                }else{
                    let newDate=new Date();
                    let detas = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
                    util.set("strDate",detas);
                    resolve(detas);
                }
            } else if(str=="remotefeUrl"){ //获取偏远费
                let remotefeUrl = util.get("remotefeUrl");
                if(remotefeUrl){
                    resolve(remotefeUrl);
                }else{
                    http.get('bms/quoteremotefee/url/find', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("remotefeUrl", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            } else if(str=="remotefe"){
                let remotefe = util.get("remotefe");
                if(remotefe){
                    resolve(remotefe);
                }else{
                    http.get('bms/quoteremotefee/front/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("remotefe", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            } else if(str=="quotefuel"){
                let quotefuel = util.get("quotefuel");
                if(quotefuel){
                    resolve(quotefuel)
                }else{
                    http.get('bms/quotefuel/transfer/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("quotefuel", res);
                            resolve(res)
                        }
                    }).catch(res => {
                    });
                }
            } else if(str=="packing"){
                let packing = util.get("packing");
                if(packing){
                    resolve(packing);
                }else{
                    http.get('bms/quotepackingfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("packing", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            } else if(str=="packingOpt"){
                let packingOpt = util.get("packingOpt");
                if(packingOpt){
                    resolve(packingOpt);
                }else{
                    http.get('bms/quotepackingfee/opt/using/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("packingOpt", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            } else if(str=="quotepremiumfee"){
                let quotepremiumfee = util.get("quotepremiumfee");
                if(quotepremiumfee){
                    resolve(quotepremiumfee);
                }else{
                    http.get('bms/quotepremiumfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("quotepremiumfee", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            }
        }
    });
}

const getOtherExch = function (str) {
    return new Promise((resolve,reject) => {
        if(str){
            http.get('bas/curotherexch/exch', str, {isShowMessage: 1}).then(res => {
                resolve(res);
            }).catch(res => {
            });
        }
    });
};

//获取偏远费验证路由
const loginQuoteRemotefeeUrl= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("remotefeUrl")) {
            http.get('bms/quoteremotefee/url/find', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefeUrl", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("remotefeUrl");
            http.get('bms/quoteremotefee/url/find', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefeUrl", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    })
};
//获取偏远费
const loginQuoteRemotefee= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("remotefe")) {
            http.get('bms/quoteremotefee/front/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefe", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("remotefe");
            http.get('bms/quoteremotefee/front/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefe", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });

};
//获取燃油信息
const loginQuotefuel= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("quotefuel")) {
            http.get('bms/quotefuel/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotefuel", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("quotefuel");
            http.get('bms/quotefuel/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotefuel", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });

};

//获取包装费规则
const loginPackingFee= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("packing")) {
            http.get('bms/quotepackingfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packing", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("packing");
            http.get('bms/quotepackingfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packing", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });

};
//获取包装费明细
const loginPackingOpt= function (){
    return new Promise((resolve,reject) => {
        if (!util.get("packingOpt")) {
            http.get('bms/quotepackingfee/opt/using/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packingOpt", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("packingOpt");
            http.get('bms/quotepackingfee/opt/using/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packingOpt", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });
};
//获取超值费用查询
const loginQuotepremiumfee= function (){
    return new Promise((resolve,reject) => {
        if (!util.get("quotepremiumfee")) {
            http.get('bms/quotepremiumfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotepremiumfee", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("quotepremiumfee");
            http.get('bms/quotepremiumfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotepremiumfee", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });
};



export default zmRemoteFee;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmQueryRemoteFeeService.js